import cls from "classnames";
import useCouponState from "store/couponState";
import {getTemporalLabelForRecurringChannelType} from "../../../../../common/helpers/channel";
import {MultiCurrency} from "../../../../../common/utils/currency";
import useAppState from "../../../store/appState";
import useEntityStore from "../../../store/entityStore";

export default function PlanCard ({data, isSelected}) {
  const {
    uid,
    currency,
    amount,
    plan_type,
    discount_tag,
    discount,
    amount_after_discount,
    interval,
    duration
  } = data;

  const entity = useEntityStore(state => state.entity);
  const setSelectedPlan = useAppState(state => state.setSelectedPlan);
  const couponDUMMY = useCouponState(state => state.coupon);
  const order = useAppState(state => state.order);

  const temporalLabel = getTemporalLabelForRecurringChannelType({
    planType: plan_type,
    interval,
    duration
  });

  let discountPercentLabel = discount ? `${discount}% OFF` : null;
  let displayAmount = amount_after_discount || amount;

  let strikeAmountLabel = discount ? MultiCurrency.formatAmountWithSymbol(amount, currency) : null;

  const couponDiscountForThisPlan = order.coupon?.data.plans ? order.coupon?.data.plans[uid] : false;

  if(!!couponDiscountForThisPlan) {
    // override to this final amount for this plan coming from api
    displayAmount= couponDiscountForThisPlan.amount_after_discount;

    // display additional discount tag
    discountPercentLabel = (
      <span>
        {discountPercentLabel}
        <span
          className="ml-1 inline-block px-[.3rem] rounded-sm animate-bounce-in bg-[#E7FFEC] text-[#4E985E]"
        >

          {
            discountPercentLabel && <span className="text-base leading-3">+</span>
          }

          {order.coupon.data.discountText}
        </span>
      </span>
    );

    strikeAmountLabel = MultiCurrency.formatAmountWithSymbol(amount, currency);
  }

  const displayAmountLabel = MultiCurrency.formatAmountWithSymbol(displayAmount, currency);

  const onChangePlan = (id) => {
    const selectedPlan = entity.data.payment.plans.find(plan => plan.data.uid === id);

    setSelectedPlan(selectedPlan);
  };

  return (
    <RadioButton
      name="plan"
      value={uid}
      isChecked={isSelected}
      onChange={onChangePlan}
    >
      <div className={cls(
        "relative w-full flex flex-row justify-between items-center py-3 px-4",
        "rounded border",
        "cursor-pointer",
        "hover-bg-primary-light",
        isSelected && "border-2 bg-primary-light",
        isSelected ? "border-primary" : "border-primary-light"
      )}>
        <div
          className="absolute right-4 -top-3 text-[13px] leading-5 rounded-[3px] bg-gradient"
          style={{
            color: '#fff'
          }}
        >
          <div className="animate-glimmer relative px-2.5 overflow-hidden">
            {discount_tag}
          </div>
        </div>

        <div className="flex flex-col items-start">
          <span className="text-[13px] font-bold text-primary">
            {discountPercentLabel}
          </span>
          <div>
            <span className="font-bold text-lg">{displayAmountLabel}</span>
            <span className="line-through text-sm text-[#5C5F62] ml-2">{strikeAmountLabel}</span>
          </div>
        </div>

        <div className="text-base font-semibold">
          {temporalLabel}
        </div>
      </div>
    </RadioButton>
  );
}

export function RadioButton({ name, value, isChecked, onChange, children }) {
  function _onChange(e) {
    const { id } = e.currentTarget;

    onChange && onChange(id);
  }

  return (
    <label htmlFor={value}>
      <input
        type="radio"
        className="hidden"
        name={name}
        id={value}
        checked={isChecked}
        onChange={_onChange}
      />
      {children}
    </label>
  );
}
